"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = makeSigner;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _utils = require("../../utils");

// A simple Ethers Signer built directly from a Web3 provider.
function makeSigner(web3Service) {
  var provider = web3Service.web3Provider();
  var call = (0, _utils.promisify)(web3Service._web3.eth.call);
  return {
    getAddress: function getAddress() {
      return web3Service.currentAddress();
    },
    estimateGas: function estimateGas(tx) {
      return web3Service.estimateGas(tx);
    },
    sendTransaction: function sendTransaction(tx) {
      return web3Service.sendTransaction((0, _objectSpread2["default"])({}, tx, {
        from: web3Service.currentAddress()
      }));
    },
    provider: new Proxy(provider, {
      get: function get(target, key) {
        switch (key) {
          case 'resolveName':
            return function (address) {
              return address;
            };

          case 'call':
            return call;

          default:
            return target[key];
        }
      }
    })
  };
}